import { withState, withHandlers, compose, pure, lifecycle } from "recompose";

export const withUnlockTopNine = compose(
  withState("successModalOpen", "setSuccessModalOpen", false),
  withHandlers({
    handleSetStatus: props => status => {
      if (status === "success") {
        props.setSuccessModalOpen(true);
      }
      props.onStatusChange(status);
    },
    onRequestClose: props => () => {
      props.setSuccessModalOpen(false);
    },
  })
);
